<template>
  <h1><em>av</em>alanche <em>da</em>ta <em>vis</em>ualization</h1>
</template>
